module.exports = __webpack_public_path__ + "img/hero_image_strong_together.2cb4fe4.jpg";